import { eventBus, EVENTS } from "../../event_bus.js";
import LoginForm from "../auth/login_form.vue";
import RegisterForm from "../auth/register_form.vue";
import { Modal, Switcher, Tumbler } from "../../elements";
export default {
  name: "Forms",
  components: {
    LoginForm,
    RegisterForm,
    Switcher,
    Tumbler
  },
  props: {
    userLogin: String
  },
  methods: {
    close() {
      this.$refs.forms.close();
    },

    show() {
      this.$refs.forms.show();
    }

  },

  created() {
    eventBus.$on(EVENTS.User.Auth.Success, this.close);
  },

  destroyed() {
    eventBus.$off(EVENTS.User.Auth.Success, this.close);
  }

};